import type { DeriveFieldsHash } from '@atlassian/jira-software-roadmap-model/src/configuration/index.tsx';
import type { DeriveFields } from './types';

export const transformDerivedFieldsHash = (derivedFields: DeriveFields): DeriveFieldsHash =>
	derivedFields.reduce<DeriveFieldsHash>((acc, deriveField) => {
		acc[deriveField.id] = [...deriveField.values];
		return acc;
	}, {});
